/**
 * Import Fee Estimator Block
 * Calculates estimated customs duty, VAT/GST, and UPS brokerage fees
 * for international customers based on their selected country and product price.
 *
 * Rates are approximate for HS code ~8714 (motorcycle parts/accessories).
 */

const IMPORT_FEE_RATES = {
  // -- North America --
  CA: {
    name: 'Canada',
    vatRate: 0.05,
    dutyRate: 0.06,
    brokerageFee: 3295,
    deMinimis: 40,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  MX: {
    name: 'Mexico',
    vatRate: 0.16,
    dutyRate: 0.10,
    brokerageFee: 2000,
    deMinimis: 50,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },

  // -- Europe --
  GB: {
    name: 'United Kingdom',
    vatRate: 0.20,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 135,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  DE: {
    name: 'Germany',
    vatRate: 0.19,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  FR: {
    name: 'France',
    vatRate: 0.20,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  IT: {
    name: 'Italy',
    vatRate: 0.22,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  ES: {
    name: 'Spain',
    vatRate: 0.21,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  NL: {
    name: 'Netherlands',
    vatRate: 0.21,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  BE: {
    name: 'Belgium',
    vatRate: 0.21,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  AT: {
    name: 'Austria',
    vatRate: 0.20,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  SE: {
    name: 'Sweden',
    vatRate: 0.25,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  DK: {
    name: 'Denmark',
    vatRate: 0.25,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  FI: {
    name: 'Finland',
    vatRate: 0.255,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  IE: {
    name: 'Ireland',
    vatRate: 0.23,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  PT: {
    name: 'Portugal',
    vatRate: 0.23,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  PL: {
    name: 'Poland',
    vatRate: 0.23,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  CZ: {
    name: 'Czech Republic',
    vatRate: 0.21,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  GR: {
    name: 'Greece',
    vatRate: 0.24,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  RO: {
    name: 'Romania',
    vatRate: 0.19,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  HU: {
    name: 'Hungary',
    vatRate: 0.27,
    dutyRate: 0.04,
    brokerageFee: 1500,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  NO: {
    name: 'Norway',
    vatRate: 0.25,
    dutyRate: 0.00,
    brokerageFee: 2000,
    deMinimis: 0,
    deMinimisWaivesDuty: false,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  CH: {
    name: 'Switzerland',
    vatRate: 0.081,
    dutyRate: 0.00,
    brokerageFee: 2500,
    deMinimis: 65,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: true
  },
  TR: {
    name: 'Turkey',
    vatRate: 0.20,
    dutyRate: 0.10,
    brokerageFee: 2000,
    deMinimis: 22,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },

  // -- Asia Pacific --
  AU: {
    name: 'Australia',
    vatRate: 0.10,
    dutyRate: 0.05,
    brokerageFee: 8800,
    deMinimis: 1000,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: true
  },
  NZ: {
    name: 'New Zealand',
    vatRate: 0.15,
    dutyRate: 0.05,
    brokerageFee: 5000,
    deMinimis: 265,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: true
  },
  JP: {
    name: 'Japan',
    vatRate: 0.10,
    dutyRate: 0.00,
    brokerageFee: 0,
    deMinimis: 66,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: true
  },
  KR: {
    name: 'South Korea',
    vatRate: 0.10,
    dutyRate: 0.08,
    brokerageFee: 2000,
    deMinimis: 150,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: false
  },
  SG: {
    name: 'Singapore',
    vatRate: 0.09,
    dutyRate: 0.00,
    brokerageFee: 0,
    deMinimis: 295,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: true
  },
  MY: {
    name: 'Malaysia',
    vatRate: 0.08,
    dutyRate: 0.10,
    brokerageFee: 1500,
    deMinimis: 115,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: true,
    deMinimisWaivesBrokerage: false
  },
  TH: {
    name: 'Thailand',
    vatRate: 0.07,
    dutyRate: 0.10,
    brokerageFee: 1500,
    deMinimis: 40,
    deMinimisWaivesDuty: false,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  IN: {
    name: 'India',
    vatRate: 0.18,
    dutyRate: 0.15,
    brokerageFee: 3000,
    deMinimis: 0,
    deMinimisWaivesDuty: false,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },

  // -- Middle East & Africa --
  IL: {
    name: 'Israel',
    vatRate: 0.17,
    dutyRate: 0.06,
    brokerageFee: 2000,
    deMinimis: 75,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  AE: {
    name: 'United Arab Emirates',
    vatRate: 0.05,
    dutyRate: 0.05,
    brokerageFee: 1500,
    deMinimis: 70,
    deMinimisWaivesDuty: true,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },
  ZA: {
    name: 'South Africa',
    vatRate: 0.15,
    dutyRate: 0.08,
    brokerageFee: 2500,
    deMinimis: 0,
    deMinimisWaivesDuty: false,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  },

  // -- South America --
  BR: {
    name: 'Brazil',
    vatRate: 0.17,
    dutyRate: 0.20,
    brokerageFee: 5000,
    deMinimis: 50,
    deMinimisWaivesDuty: false,
    deMinimisWaivesVat: false,
    deMinimisWaivesBrokerage: false
  }
};

class ImportFeeEstimator {
  constructor() {
    this.basePrice = 0;
    this.addonsTotal = 0;
    this.selectedCountry = '';

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.wrapper = document.querySelector('[data-import-fee-estimator]');
    if (!this.wrapper) return;

    this.basePrice = parseInt(this.wrapper.dataset.basePrice) || 0;

    this.countrySelect = this.wrapper.querySelector('[data-import-fee-country]');
    this.resultsContainer = this.wrapper.querySelector('[data-import-fee-results]');
    this.productValueEl = this.wrapper.querySelector('[data-import-fee-product-value]');
    this.dutyEl = this.wrapper.querySelector('[data-import-fee-duty]');
    this.vatEl = this.wrapper.querySelector('[data-import-fee-vat]');
    this.brokerageEl = this.wrapper.querySelector('[data-import-fee-brokerage]');
    this.totalEl = this.wrapper.querySelector('[data-import-fee-total]');
    this.deMinimisEl = this.wrapper.querySelector('[data-import-fee-deminimis]');

    this.setupCountryListener();
    this.setupVariantListeners();
    this.setupAddonListeners();
  }

  setupCountryListener() {
    if (!this.countrySelect) return;
    this.countrySelect.addEventListener('change', () => {
      this.selectedCountry = this.countrySelect.value;
      this.calculate();
    });
  }

  setupVariantListeners() {
    // Listen for variant:change custom event (used by theme custom blocks)
    document.addEventListener('variant:change', (event) => {
      if (event.detail && event.detail.variant && event.detail.variant.price != null) {
        this.basePrice = event.detail.variant.price;
        this.calculate();
      }
    });

    // Listen for form input changes as fallback
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(form => {
      form.addEventListener('change', (event) => {
        if (event.target.name === 'id') {
          this.fetchVariantPrice(event.target.value);
        }
      });
    });
  }

  setupAddonListeners() {
    document.addEventListener('addon:changed', () => {
      this.recalculateAddonsTotal();
      this.calculate();
    });

    const addonDropdowns = document.querySelectorAll('[data-addon-select]');
    addonDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', () => {
        this.recalculateAddonsTotal();
        this.calculate();
      });
    });
  }

  recalculateAddonsTotal() {
    this.addonsTotal = 0;
    if (window.productAddons && typeof window.productAddons.getSelectedAddons === 'function') {
      const selectedAddons = window.productAddons.getSelectedAddons();
      selectedAddons.forEach(addon => {
        if (addon.type === 'product' && addon.price) {
          this.addonsTotal += addon.price;
        }
      });
    }
  }

  async fetchVariantPrice(variantId) {
    try {
      const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (!productHandle) return;
      const response = await fetch('/products/' + productHandle + '.js');
      const productData = await response.json();
      const variant = productData.variants.find(function(v) { return v.id == variantId; });
      if (variant && variant.price) {
        this.basePrice = variant.price;
        this.calculate();
      }
    } catch (error) {
      console.error('Import Fee Estimator: Error fetching variant data:', error);
    }
  }

  getTotalProductValue() {
    return this.basePrice + this.addonsTotal;
  }

  calculate() {
    if (!this.selectedCountry || !this.resultsContainer) return;

    var rates = IMPORT_FEE_RATES[this.selectedCountry];
    if (!rates) {
      this.resultsContainer.classList.remove('is-visible');
      return;
    }

    var totalValueCents = this.getTotalProductValue();
    var totalValueUSD = totalValueCents / 100;

    var belowDeMinimis = rates.deMinimis > 0 && totalValueUSD <= rates.deMinimis;

    // Customs duty
    var dutyRate = (belowDeMinimis && rates.deMinimisWaivesDuty) ? 0 : rates.dutyRate;
    var dutyCents = Math.round(totalValueCents * dutyRate);

    // VAT/GST is assessed on (product value + duty)
    var vatRate = (belowDeMinimis && rates.deMinimisWaivesVat) ? 0 : rates.vatRate;
    var vatBaseCents = totalValueCents + dutyCents;
    var vatCents = Math.round(vatBaseCents * vatRate);

    // UPS brokerage fee (flat)
    var brokerageCents = (belowDeMinimis && rates.deMinimisWaivesBrokerage) ? 0 : rates.brokerageFee;

    var totalFeesCents = dutyCents + vatCents + brokerageCents;

    this.updateDisplay({
      productValue: totalValueCents,
      duty: dutyCents,
      dutyRate: dutyRate,
      vat: vatCents,
      vatRate: vatRate,
      brokerage: brokerageCents,
      total: totalFeesCents,
      belowDeMinimis: belowDeMinimis,
      deMinimis: rates.deMinimis,
      countryName: rates.name
    });
  }

  updateDisplay(data) {
    this.resultsContainer.classList.add('updating');
    setTimeout(() => this.resultsContainer.classList.remove('updating'), 300);

    this.resultsContainer.classList.add('is-visible');

    if (this.productValueEl) {
      this.productValueEl.textContent = this.formatMoney(data.productValue);
    }
    if (this.dutyEl) {
      this.dutyEl.textContent = this.formatMoney(data.duty) + ' (' + (data.dutyRate * 100).toFixed(1) + '%)';
    }
    if (this.vatEl) {
      this.vatEl.textContent = this.formatMoney(data.vat) + ' (' + (data.vatRate * 100).toFixed(1) + '%)';
    }
    if (this.brokerageEl) {
      this.brokerageEl.textContent = this.formatMoney(data.brokerage);
    }
    if (this.totalEl) {
      this.totalEl.textContent = this.formatMoney(data.total);
    }

    if (this.deMinimisEl) {
      if (data.belowDeMinimis) {
        this.deMinimisEl.textContent = 'Your order is below the ' + data.countryName +
          ' de minimis threshold of $' + data.deMinimis + ' USD. Some fees may be waived.';
        this.deMinimisEl.style.display = 'block';
      } else {
        this.deMinimisEl.style.display = 'none';
      }
    }
  }

  formatMoney(cents) {
    var moneyFormat = (window.theme && window.theme.moneyFormat)
      || (typeof Shopify !== 'undefined' && Shopify.money_format)
      || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.importFeeEstimator = new ImportFeeEstimator();
  });
} else {
  window.importFeeEstimator = new ImportFeeEstimator();
}
